var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PolicyEmbed',{attrs:{"title":"Terms of Service","subtitle":"The guidelines for playing, merging, and enjoying Spooky Merge.","src":"https://joy2ever-policy.com/spooky-merge/view#spooky-merge_terms-of-service"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e663a0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TermsOfService.vue
// module id = null
// module chunks = 